






















































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { InvoiceListModule } from '@/store/modules/invoiceList';
import Alert from '@/components/Shared/Alert.vue'
import InvoiceDto from '@/models/Invoices/InvoiceDto'
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import InvoiceCreate from '@/components/Invoices/InvoiceCreate.vue';
import InvoiceStatus from '@/components/Invoices/Display/InvoiceStatus.vue';
import InvoiceListSearchCriteria from '@/components/Invoices/InvoiceListSearchCriteria.vue';

@Component({
  name: 'AgencyInvoices',
  components: { Alert, InvoiceCreate, InvoiceStatus, InvoiceListSearchCriteria }
})
export default class extends GiganautVue {

  async navigateToInvoice(invoiceId: string) {
    this.$router.push({ name: PageNames.AgencyInvoiceDetails, params: { invoiceid: invoiceId } });
  }

  get loading() {
    return InvoiceListModule.loading;
  }
   
  private search = '';

  get invoices() {
    return InvoiceListModule.invoices;
  }

  private headers = [
    { text: 'Ref', value: 'sequenceNumber' },
    { text: 'Type', value: 'type' },
    { text: 'Recipient'},
    { text: 'Week Commencing', value: 'weekCommencingDate ' },
    { text: 'Period', value: 'earliestStartAt' },
    { text: 'Status', value: 'status'},
    { text: 'Accounts Number', value: 'number'},
    { text: 'Actions' },
  ]
}
